// extracted by mini-css-extract-plugin
export default {"header":"Header_header__c0oxC","brand":"Header_brand__620X7","mark":"Header_mark__W58h4"};